import { HttpParams } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Analytics, logEvent } from "@angular/fire/analytics";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-product-redirect",
  templateUrl: "./product-redirect.component.html",
  styleUrls: ["./product-redirect.component.css"],
})
export class ProductRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    analytics: Analytics,
  ) {
    const params = this.route.snapshot.queryParams;
    const referrerId = params["id"];
    const name = params["name"];
    let httpParams = new HttpParams();
    const entries = Object.entries(params);
    let index = 0;

    while (index < entries.length) {
      const [key, value] = entries[index];

      if (key === "id") {
        httpParams = httpParams.append("referrer", value);
      } else if (key === "name") {
        httpParams = httpParams.append("name", value);
        httpParams = httpParams.append("utm_source", value);
      } else {
        httpParams = httpParams.append(key, value);
      }
      index++;
    }

    const url = `${environment.qrproductUrl}?${httpParams.toString()}`;
    logEvent(analytics, "product-redirect", { referrerId, name });
    window.location.href = url;
  }

  ngOnInit(): void {}
}
